import { styled } from 'styled-components';
import THEME from '../../theme.js';
// No gap: the toolbar and panels each bring their own bottom margin.
export const ReportContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const ReportToolbar = styled.div `
  display: flex;
  align-items: center;
  gap: ${THEME.GRID_SPACING}px;
  margin-bottom: ${THEME.GRID_SPACING}px;

  /* The selects carry a bottom margin meant for forms. */
  > div > div {
    margin-bottom: 0;
  }
`;
export const ReportFilter = styled.div `
  width: 260px;
`;
// A chart beside its stat tiles.
export const ReportSummary = styled.div `
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: ${THEME.GRID_SPACING}px;
`;
//# sourceMappingURL=ReportLayout.js.map